module.exports = __webpack_public_path__ + "static/user_flow-400714d0e18fb19ada56ce36eadab2dd.png";